import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { Navbar, Container, Nav } from 'react-bootstrap';
import { HiSparkles, HiOutlineTag } from './components/Icons';
import Home from './Home';
import Company from './Company';
import Category from './Category';
import ActivityTicker from './components/ActivityTicker';
import PWAInstallBanner from './components/PWAInstallBanner';
import LanguageToggle from './components/LanguageToggle';
import { LanguageProvider, useLanguage } from './context/LanguageContext';
import './App.css';
import AppFooter from './components/footer';

function AppContent() {
  const { t } = useLanguage();

  return (
    <Router>
      <div className="app-layout">
        {/* Top Notification Announcement Bar */}
        <div className="top-banner">
          <Container className="d-flex justify-content-center align-items-center gap-2">
            <span className="banner-badge">
              <HiSparkles className="me-1" /> {t('topBannerBadge', 'Neu')}
            </span>
            <span className="banner-text">
              {t('topBannerText', 'Exklusive Deals: Jetzt bis zu 85.000 Membership Rewards® Punkte bei American Express sichern!')}
            </span>
          </Container>
        </div>

        {/* Main Navbar */}
        <Navbar className="modern-navbar sticky-top" expand="lg">
          <Container>
            <Navbar.Brand as={Link} to="/" className="modern-brand">
              <div className="brand-vector-icon">
                <HiSparkles className="brand-svg-icon" />
              </div>
              <div className="brand-text-block">
                <span className="brand-title">
                  Coupon<span className="brand-title-gradient">Showcase</span>
                </span>
                <span className="brand-tagline">{t('tagline', 'Deals & Gutscheine')}</span>
              </div>
            </Navbar.Brand>

            <Navbar.Toggle aria-controls="main-navbar-nav" className="custom-toggler" />

            <Navbar.Collapse id="main-navbar-nav" className="justify-content-end">
              <Nav className="align-items-center gap-lg-2">
                <Nav.Link as={Link} to="/" className="nav-item-link active">
                  <HiOutlineTag className="me-1" /> {t('navAllVouchers', 'Alle Gutscheine')}
                </Nav.Link>
                <Nav.Link href="/#categories" className="nav-item-link">
                  {t('navCategories', 'Kategorien')}
                </Nav.Link>
                <Nav.Link href="/american_express_platinum" className="nav-highlight-btn">
                  <HiSparkles className="me-1" /> {t('navTopDeal', 'Top Deal: Amex')}
                </Nav.Link>
                <div className="ms-lg-2 mt-2 mt-lg-0">
                  <LanguageToggle />
                </div>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>

        {/* Slogan Banner container for SEO & brand statement */}
        <div className="slogan-container">
          <Container>
            <div className="slogan">
              <span className="first-letter">C</span>oupon Showcase, {t('sloganPrefix', 'Ihr Ziel für')} <span className="highlight">{t('sloganHighlight1', 'erstklassige')}</span>, <span className="highlight">{t('sloganHighlight2', 'handverlesene')}</span> {t('sloganRest', 'Gutscheine und Rabatte, um Ihnen das beste')} <span className="highlight">{t('sloganHighlight3', 'Sparerlebnis')}</span> {t('sloganSuffix', 'zu bieten!')}
            </div>
          </Container>
        </div>

        {/* Main Content View */}
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/kategorie/:categorySlug" element={<Category />} />
            <Route path="/:companyId" element={<Company />} />
          </Routes>
        </main>

        {/* Footer */}
        <footer id="footer">
          <AppFooter />
        </footer>

        {/* Live Social Proof Activity Ticker */}
        <ActivityTicker />

        {/* PWA Mobile & Desktop Install Prompt */}
        <PWAInstallBanner />
      </div>
    </Router>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AppContent />
    </LanguageProvider>
  );
}

export default App;
